import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconSquareRemove = createIcon({
  displayName: 'IconSquareRemove',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M3 3H21V5H5V19H19V7H21V21H3V3ZM7 11H17V13H7V11Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
